import { useReducer, useState, useEffect } from 'react';

const initialInputState = {
  value: '',
  isTouched: false,
};

const inputStateReducer = (state, action) => {
  if (action.type === 'INPUT') {
    return { isTouched: state.isTouched, value: action.value };
  }
  if (action.type === 'TOUCH') {
    return { isTouched: true, value: state.value };
  }
  if (action.type === 'ERROR') {
    return { isTouched: true, value: state.value };
  }
  if (action.type === 'BLUR') {
    return { isTouched: true, value: state.value };
  }
  if (action.type === 'RESET') {
    return { isTouched: false, value: '' };
  }
  return inputStateReducer;
};

export default function useInput(validateValue) {
  const [inputState, dispatch] = useReducer(
    inputStateReducer,
    initialInputState
  );

  const [valueIsValid, setValueIsValid] = useState(true);
  const [hasError, setHasError] = useState(false);

  const valueValid = validateValue(inputState.value);
  const error = !valueIsValid && inputState.isTouched;

  useEffect(() => {
    setValueIsValid(validateValue(inputState.value));
  }, [valueValid]);
  useEffect(() => {
    setHasError(!valueIsValid && inputState.isTouched);
  }, [error]);

  const valueChangeHandler = (event) => {
    setValueIsValid(validateValue(event.target.value));
    dispatch({ type: 'INPUT', value: event.target.value });
  };

  const valueTouchHandler = () => {
    setValueIsValid(validateValue(inputState.value));
    dispatch({ type: 'INPUT', value: inputState.value });
  };

  const valueErrorHandler = () => {
    setHasError(true);
    setValueIsValid(false);
    dispatch({ type: 'ERROR' });
  };

  const inputBlurHandler = (event) => {
    dispatch({ type: 'BLUR' });
  };

  const reset = () => {
    dispatch({ type: 'RESET' });
  };

  return {
    value: inputState.value,
    isValid: valueIsValid,
    hasError,
    valueChangeHandler,
    valueTouchHandler,
    valueErrorHandler,
    inputBlurHandler,
    reset,
  };
};
